import { render } from "./BankAccountSearch.vue?vue&type=template&id=9b708382"
import script from "./BankAccountSearch.vue?vue&type=script&lang=js"
export * from "./BankAccountSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__